<div class="referral-not-applied" data-id="referral-credit-not-applied">
  <img
    src="assets/icons/warning.svg"
    alt=""
    width="20"
    height="20"
    class="referral-not-applied__icon"
  />
  <div>
    <p class="semi-bold referral-not-applied__title">{{ copy.title }}</p>
    <p class="referral-not-applied__body">{{ copy.body }}</p>
  </div>
</div>
